module.exports = __webpack_public_path__ + "media/images/massage/main_image1-a4bd27c4fad0d80b5eedb75281389522.jpg";